import { FilterResultFacade } from '../../filter-result-facade';
import {
  FilterOptions,
  FilterPassParams,
  IFilterComparator,
  InclusiveExclusiveFilterModel
} from '../../filter-types';
import { filterInclusiveExclusiveValues } from '../../filter-utils';
import { InclusiveExclusiveModelComparator } from '../comparators/inclusive-exclusive-model-comparator';
import { FilterHandlerBase } from './filter-handler-base';

export abstract class InclusiveExclusiveFilterHandler extends FilterHandlerBase {
  private comparator: IFilterComparator<InclusiveExclusiveFilterModel>;
  protected abstract getValue(params: FilterPassParams): string[];

  abstract getFilterOptions(filterOptions: FilterOptions): string[];

  get isInclusiveExclusive(): boolean {
    return true;
  }

  doFilterPass(params: FilterPassParams, result: FilterResultFacade) {
    let filterPassed = true;
    const filter = params.filters[this.name];
    if (filter) {
      const model: InclusiveExclusiveFilterModel = filter.model as InclusiveExclusiveFilterModel;
      filterPassed = filterInclusiveExclusiveValues(
        model,
        this.getValue(params),
        this.getFilterOptions(params.options)
      );
    }
    result.applyDealFilerResult(params.deal.id, this.name, filterPassed);

    return filterPassed;
  }

  hasValidDiff(options: FilterOptions, grid: any, store: any): boolean {
    return this.getValidDiffComparator(options).hasValidDiff(grid, store);
  }

  getValidDiffComparator(
    options: FilterOptions
  ): IFilterComparator<InclusiveExclusiveFilterModel> {
    if (!this.comparator) {
      this.comparator = new InclusiveExclusiveModelComparator();
    }
    this.comparator.applyFilterOptions(this.getFilterOptions(options));
    return this.comparator;
  }
}
